export const API_URL = "https://api.marketpro.ch/api/";
export const ASSET_DOMAIN = "https://api.marketpro.ch";
export default {}
